/**
 * @file 二维码相关文件
 */
import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/**
 * 通过url和宽高生成二维码图片，以链接方式返回
 */
export const useQRCode = (url: string, width: number, height: number) => {
  const [src, setSrc] = useState('');

  useEffect(() => {
    if (url) {
      const generateQR = async () => {
        try {
          const canvas = document.createElement('canvas');
          QRCode.toCanvas(canvas, url, {
            width: width,
            height: height,
          } as any);
          const imageURL = canvas.toDataURL('image/png');
          setSrc(imageURL);
        } catch (error) {
          console.error('Error generating QR code:', error);
        }
      };

      generateQR();
    }

    // 清理函数
    return () => {
      // 如果有需要清理的资源，可以在这里进行
      if (src) {
        URL.revokeObjectURL(src);
        setSrc('');
      }
    };
  }, [url, width, height]);

  return { src };
};

export default useQRCode;
